import { render, staticRenderFns } from "./masivos.vue?vue&type=template&id=1f38d2b3"
import script from "./masivos.vue?vue&type=script&lang=js"
export * from "./masivos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports